import type { IconProps } from '../types/IconProps.ts';
export const Bolt: IconProps = {
    name: 'Bolt',
    children: [
        `<path d="M3 8.18a2 2 0 0 1 1.03-1.75l7-3.89a2 2 0 0 1 1.94 0l7 3.89A2 2 0 0 1 21 8.18v7.64a2 2 0 0 1-1.03 1.75l-7 3.89a2 2 0 0 1-1.94 0l-7-3.89A2 2 0 0 1 3 15.82z" />`,
        `<circle cx="12" cy="12" r="4" />`,
    ]
};